import { useWizardOutlet } from './useWizard'

export const WizardOutlet = () => {
  const { element } = useWizardOutlet()

  return element
}

export default WizardOutlet
